import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import {
  CompanyInfo,
  General,
  PersonalInfo,
} from '../../core/store/general/models/general';

@Injectable({
  providedIn: 'root',
})
export class GeneralService {
  private baseApiUrl: string = environment.API_BASE_URL;

  constructor(private readonly http: HttpClient) {}

  getGeneral(): Observable<General> {
    return this.http.get<General>(`${this.baseApiUrl}/general`);
  }

  updateGeneralPersonalInfo(
    personalInfo: PersonalInfo,
  ): Observable<PersonalInfo> {
    return this.http.put<PersonalInfo>(
      `${this.baseApiUrl}/general/personal-info`,
      personalInfo,
    );
  }

  updateGeneralCompanyInfo(companyInfo: CompanyInfo): Observable<CompanyInfo> {
    return this.http.put<CompanyInfo>(
      `${this.baseApiUrl}/general/company-info`,
      companyInfo,
    );
  }

  /**
   * Deactivates the whole account. Owner only — the API enforces that too. Every
   * member is locked out the moment this returns, so the caller signs out rather
   * than navigating: any further request answers 403 tenant_deactivated.
   */
  deleteTenant(): Observable<void> {
    return this.http.delete<void>(`${this.baseApiUrl}/general/delete`);
  }
}
